/**
 * Pure capability check for the navigation guard. Returns a redirect target when the
 * destination declares `meta.requiresCapability` and the user's capability set does not
 * include it; otherwise null (navigation allowed). Defense-in-depth — the backend still
 * enforces the right with a 403.
 *
 * Takes only `matched` so `resolveLandingRedirect` can pre-flight a `router.resolve(...)`
 * result through the SAME check the guard applies to a real navigation — two copies of
 * "which meta key gates this route" would let the landing pre-flight and the guard drift.
 * `requiredCapability` below is that lookup, exported so a caller can ask whether a route
 * is gated at all before paying for the capability set.
 */
export function requiredCapability(to) {
    return to.matched
        .map((record) => record.meta?.requiresCapability)
        .find((cap) => typeof cap === "string");
}
export function resolveCapabilityRedirect(to, capabilities) {
    const required = requiredCapability(to);
    if (!required) {
        return null;
    }
    return capabilities.includes(required) ? null : { path: "/error/403" };
}
